module.exports = __webpack_public_path__ + "img/18_59.d49b0361.png";